import { MessageSquare, ThumbsUp } from "lucide-react";
import type React from "react";
import "./BlockInteractions.css";

interface BlockInteractionsProps {
	blockId: string;
	likes: number;
	userHasLiked?: boolean;
	commentCount?: number;
	isCommenting?: boolean;
	onLike?: (blockId: string) => void;
	onComment?: (blockId: string) => void;
}

export const BlockInteractions: React.FC<BlockInteractionsProps> = ({
	blockId,
	likes,
	userHasLiked = false,
	commentCount = 0,
	isCommenting = false,
	onLike,
	onComment,
}) => {
	return (
		<div className="block-interactions">
			<button
				type="button"
				className={`interaction-btn like-btn ${userHasLiked ? "liked" : ""}`}
				onClick={() => !userHasLiked && onLike?.(blockId)}
				title={userHasLiked ? "You liked this" : "Like this section"}
				disabled={userHasLiked}
			>
				<ThumbsUp size={16} />
				{likes > 0 && <span className="count">{likes}</span>}
			</button>
			<button
				type="button"
				className={`interaction-btn comment-btn ${isCommenting ? "active" : ""}`}
				onClick={() => onComment?.(blockId)}
				title="Comment on this section"
			>
				<MessageSquare size={16} />
				{commentCount > 0 && <span className="count">{commentCount}</span>}
			</button>
		</div>
	);
};
